import {Component, Input, ViewChild} from '@angular/core';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {EmailDetailsFormComponent, EmailFormData} from '../../../../../shared/email-details-form/email-details-form.component';

export type EmailStepData = EmailFormData;

@Component({
  selector: 'app-email-step',
  standalone: true,
  imports: [EmailDetailsFormComponent],
  templateUrl: './email-step.component.html',
})
export class EmailStepComponent implements WizardStepComponent {

  @Input() initialData: EmailStepData | null;

  @ViewChild(EmailDetailsFormComponent) private emailForm: EmailDetailsFormComponent;

  isValid(): boolean {
    return this.emailForm.isValid();
  }

  getValue(): EmailStepData {
    return this.emailForm.getFormValue();
  }
}
